import {useEffect, useState} from 'react'
import {useSelector, shallowEqual} from 'react-redux'
import {Module} from 'ag-common/constants/modules'
import actions from 'redux-auto'
import useCurrentUser from '#hooks/store/useCurrentUser'

function addActivatedModulesToList(moduleSettings, list) {
  if (moduleSettings.hasPraxisaufgaben) {
    list.push(Module.praxisaufgabenOverview)
  }
  if (moduleSettings.hasNachweise) {
    list.push(Module.nachweise)
  }
  if (moduleSettings.hasVersetzungsplan) {
    list.push(Module.versetzungsplan)
  }
  if (moduleSettings.hasAusbildungsplan) {
    list.push(Module.ausbildungsplan)
  }
  if (moduleSettings.hasWissensportal) {
    list.push(Module.wissensportal)
  }
  if (moduleSettings.hasChat) {
    list.push(Module.chat)
  }

  list.push(Module.feedback)
}

const isModuleActivated = activatedModules => moduleName => {
  return activatedModules.some(module => moduleName.toLowerCase().includes(module.toLowerCase()))
}

const isModulePath = path => Object.keys(Module).some(module => path.includes(module.toLowerCase()))

export default function useUserModuleSettings() {
  const {isLoggedIn} = useCurrentUser()
  const moduleSettings = useSelector(state => state.wizardtemplate.moduleSettings, shallowEqual)
  const moduleSettingsLoading = useSelector(state => state.wizardtemplate.isLoading, shallowEqual)
  const [moduleTemplate, setModuleTemplate] = useState({
    isModulePath,
    activatedModules: [Module.meineausbildung],
    showModule: isModuleActivated([Module.meineausbildung]),
    moduleSettingsLoading,
  })
  useEffect(() => {
    if (isLoggedIn) {
      actions.wizardtemplate.getUserModuleSettings()
    }
  }, [isLoggedIn])

  useEffect(() => {
    const list = [Module.meineausbildung]
    if (moduleSettings) {
      addActivatedModulesToList(moduleSettings, list)
    }
    setModuleTemplate(moduleTemplate => ({
      ...moduleTemplate,
      activatedModules: list,
      showModule: isModuleActivated(list),
      moduleSettingsLoading,
    }))
  }, [moduleSettings, moduleSettingsLoading])

  return moduleTemplate
}
